import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Action } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { HttpClient } from '@angular/common/http';
import * as fromAllCategoryAction from '../action/all-categories.action';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { IError } from '../state/app.state';
import { AppToastrService } from '@app/@core/services/toastr/app-toastr.service';
import { IAllCategories, ICategoriesData } from '@app/@shared/Models/all-categories.model';
import { CatalogueService } from '../../../catalogue/services/catalogue.service';

@Injectable()
export class AllCategoriesEffect {
    constructor(private http: HttpClient, private action$: Actions, private appToastrService: AppToastrService, private catalogueService: CatalogueService) { }
    GetAllCategoriesList$: Observable<Action> = createEffect(() =>
        this.action$.pipe(
            ofType(fromAllCategoryAction.BeginGetAllCategoriesItems),
            mergeMap((action: any) =>
                this.catalogueService.getAllCategory().pipe(
                    map((response: IAllCategories) => {
                        if (response) {
                            let listItems: ICategoriesData = response.data;
                            return fromAllCategoryAction.AllCategoriesSuccess({ payload: listItems });
                        }
                    }),
                    catchError((error) => {
                        let mappedData: IError = { statusCode: error.status, errorMessage: error.message }
                        return of(fromAllCategoryAction.AllCategoriesError({ payload: mappedData }));
                    })
                )
            )
        )
    )
}